import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.trackSignupLinks()
    this.trackSignupStart()
    this.trackHomepageView()
    this.trackDemoRequests()
  }

  trackSignupLinks() {
    // Track sign-up link clicks
    document.querySelectorAll('a[href*="new_user_registration"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        // Get button location and page source
        const buttonLocation = this.getButtonLocation(e.target)
        const pageSource = window.location.pathname
        
        // Track with Google Analytics
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click_signup_cta', {
            'event_category': 'User Registration',
            'event_label': 'Sign-Up Initiation',
            'button_location': buttonLocation,
            'page_source': pageSource
          })
        }
      })
    })
  }

  trackSignupStart() {
    // Track when user starts filling signup form (focuses on email field)
    const emailField = document.getElementById('signup_email_field')
    
    if (emailField) {
      let hasTracked = false
      
      emailField.addEventListener('focus', () => {
        if (!hasTracked) {
          hasTracked = true
          
          // Track with Google Analytics
          if (typeof gtag !== 'undefined') {
            gtag('event', 'start_signup', {
              'event_category': 'User Registration',
              'event_label': 'Form Start',
              'page_source': window.location.pathname
            })
          }
        }
      })
    }
  }

  trackHomepageView() {
    // Track homepage impressions
    if (window.location.pathname === '/' || window.location.pathname === '') {
      // Track with Google Analytics
      if (typeof gtag !== 'undefined') {
        gtag('event', 'view_homepage', {
          'event_category': 'Page View',
          'event_label': 'Homepage Impression',
          'page_source': window.location.pathname
        })
      }
    }
  }

  trackDemoRequests() {
    // Track demo request link clicks
    document.querySelectorAll('a[href*="cal.com/isdown"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        // Get page source
        const pageSource = window.location.pathname
        
        // Track with Google Analytics
        if (typeof gtag !== 'undefined') {
          gtag('event', 'demo_request', {
            'event_category': 'Lead Generation',
            'event_label': 'Demo Request',
            'page_source': pageSource
          })
        }
      })
    })
  }

  getButtonLocation(element) {
    // Extract cta parameter from href
    const href = element.getAttribute('href')
    if (href) {
      const url = new URL(href, window.location.origin)
      const ctaParam = url.searchParams.get('cta')
      return ctaParam || 'other'
    }
    
    return 'other'
  }
}